export const logos = {
  government: '/assets/images/find-information/government.svg',
  individual: '/assets/images/find-information/individual.svg',
  nonStateArmedGroup: '/assets/images/find-information/non-stated-arm-group.svg',
  otherOrganisation: '/assets/images/find-information/other-organisation.svg',
  other: '/assets/images/find-information/other-organisation.svg',
  stateSecurityForces: '/assets/images/find-information/state-security.svg',
  corporation: '/assets/images/find-information/business-entity.svg',
  civilSociety: '/assets/images/find-information/civil-society.svg',
}
